import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { SnackbarProvider, SnackbarContext } from './SnackbarContext';
export default function withSnackbar(WrapperComponent) {
    const Comp = props => {
        return (<SnackbarProvider>
        <SnackbarContext.Consumer>
          {snackbarProps => <WrapperComponent {...snackbarProps} {...props}/>}
        </SnackbarContext.Consumer>
      </SnackbarProvider>);
    };
    return hoistNonReactStatics(Comp, WrapperComponent);
}
